import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "colorToken", "colorTokenArgs", "UNSAFE_svgProps", "children"];
import React from 'react';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import Group from '@bubble-ui/primitive-group';
import Shape from '@bubble-ui/primitive-shape';
import Surface from '@bubble-ui/primitive-surface';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';
import iconDefaultStylesheetGetter from './defaultStylesheets/icon';
export var defaultShapeSize = {
  height: 20,
  width: 20
};
export var defaultNavigationIconShapeSize = {
  height: 30,
  width: 30
};
export var defaultAlignedActionIconGroupProps = {
  fill: 'none',
  fillRule: 'evenodd',
  x: 4,
  y: 4
};
export var defaultNavigationIconGroupProps = {
  fill: 'none',
  fillRule: 'evenodd'
};
export var defaultIconGroupProps = {
  fill: 'none',
  fillRule: 'evenodd'
};
export function baseIcon(displayName, config) {
  var defaultStyleSheetGetter = (config === null || config === void 0 ? void 0 : config.defaultStyleSheetGetter) || iconDefaultStylesheetGetter;
  var shapeSize = (config === null || config === void 0 ? void 0 : config.shapeSize) || defaultShapeSize;
  var groupProps = (config === null || config === void 0 ? void 0 : config.groupProps) || {};

  var OverridableIcon = function OverridableIcon(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var color = props.color,
        colorToken = props.colorToken,
        colorTokenArgs = props.colorTokenArgs,
        UNSAFE_svgProps = props.UNSAFE_svgProps,
        children = props.children,
        restOfProps = _objectWithoutProperties(props, _excluded);

    usePropDeprecationWarning({
      componentName: displayName,
      propName: 'color',
      shouldWarn: color !== undefined,
      removalDate: 'v6.0.0'
    });
    var designVersion = useDesignVersion();
    var path = config.getPath(props);
    var styleSheetProps = config.styleSheetPropsGetter ? config.styleSheetPropsGetter(props, designVersion) : {
      color: color,
      designVersion: designVersion,
      colorToken: colorToken,
      colorTokenArgs: colorTokenArgs
    };
    var cleanRestOfProps = config !== null && config !== void 0 && config.restOfPropsSanitizer ? config.restOfPropsSanitizer(restOfProps) : restOfProps;
    var styleSheet = useStyleSheet(OverridableIcon, defaultStyleSheetGetter, styleSheetProps);
    return /*#__PURE__*/React.createElement(Surface, _extends({}, UNSAFE_svgProps, {
      height: shapeSize.height,
      width: shapeSize.width
    }, cleanRestOfProps), /*#__PURE__*/React.createElement(Group, groupProps, /*#__PURE__*/React.createElement(Shape, _extends({
      d: path
    }, styleSheet === null || styleSheet === void 0 ? void 0 : styleSheet.pathStyle))));
  };

  OverridableIcon.displayName = displayName;
  var Icon = withProvisionalOverrideFromContext(OverridableIcon);
  return Icon;
}
//# sourceMappingURL=baseIcon.js.map